'use es6';

const PASSWORD_RULE_PARTS = {
  minLength: 8,
  maxLength: 200,
  lowercase: '[a-z]',
  uppercase: '[A-Z]',
  numberSymbolWhitespace: '([\\d\\s]|[^\\w])'
};
export default PASSWORD_RULE_PARTS;